import { render, staticRenderFns } from "./admin-portal-user-form.vue?vue&type=template&id=c1f83336"
import script from "./admin-portal-user-form.vue?vue&type=script&lang=js"
export * from "./admin-portal-user-form.vue?vue&type=script&lang=js"
import style0 from "./admin-portal-user-form.vue?vue&type=style&index=0&id=c1f83336&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports